export enum RedirectEnum {
    Facebook,
    Instagram,
    Linkedin,
    Default
}